// SPDX-FileCopyrightText: 2026 Stadtplatz.de
//
// SPDX-License-Identifier: EUPL-1.2

import apiClient from "../config/api";
import { handleApiCall } from "../utils/apiHelper";

// Per-space catalog products, against /admin/spaces/{space_id}/products.
//   GET    list a space's products
//   POST   add a product (product_catalog_id, min/max quantity, is_mandatory)
//   PUT    update quantity / mandatory for a product
//   DELETE remove a product
export const spaceProductService = {
  getSpaceProducts: async (spaceId) =>
    handleApiCall(
      () => apiClient.get(`/admin/spaces/${spaceId}/products`),
      `Error fetching products for space ${spaceId}`,
    ),

  addSpaceProduct: async (spaceId, payload) =>
    handleApiCall(
      () => apiClient.post(`/admin/spaces/${spaceId}/products`, payload),
      `Error adding product to space ${spaceId}`,
    ),

  updateSpaceProduct: async (spaceId, productCatalogId, payload) =>
    handleApiCall(
      () =>
        apiClient.put(
          `/admin/spaces/${spaceId}/products/${productCatalogId}`,
          payload,
        ),
      `Error updating space ${spaceId} product ${productCatalogId}`,
    ),

  removeSpaceProduct: async (spaceId, productCatalogId) =>
    handleApiCall(
      () =>
        apiClient.delete(
          `/admin/spaces/${spaceId}/products/${productCatalogId}`,
        ),
      `Error removing product ${productCatalogId} from space ${spaceId}`,
    ),
};

export default spaceProductService;
